import axios from 'axios'
import base_url from '../../base_url.js'

let Pwa = axios.create({
    baseURL: base_url,
    withCredentials: true
})

export default Pwa;